import React from 'react';
import Typography from '@mui/material/Typography';
import { connect } from 'react-redux';
import mjml2html from 'mjml-browser';

import { saveMjml } from '../../actions';
import MjmlEditor from './mjmlEditor';

const MJML_OPEN = '<mjml><mj-body><mj-section><mj-column>';
const MJML_CLOSE = '</mj-column></mj-section></mj-body></mjml>';

const compileSnippet = async (mjmlContent) => {
    if (!mjmlContent.trim()) {
        return { html: '', error: null };
    }
    try {
        const result = await mjml2html(`${MJML_OPEN}${mjmlContent}${MJML_CLOSE}`);
        const { html, errors } = result;
        if (errors && errors.length > 0) {
            return { html: '', error: errors[0].formattedMessage };
        }
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return { html: doc.body.innerHTML, error: null };
    } catch (e) {
        return { html: '', error: e.message };
    }
};

const MjmlProps = ({ content, onSaveMjml }) => {
    const [value, setValue] = React.useState(content.config.mjml);
    const [error, setError] = React.useState(null);
    const debounceTimer = React.useRef(null);

    const compile = React.useCallback(async (id, mjmlContent) => {
        const { html, error: compileError } = await compileSnippet(mjmlContent);
        setError(compileError);
        onSaveMjml(id, mjmlContent, html);
    }, [onSaveMjml]);

    const onChange = (newValue) => {
        setValue(newValue);
        clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(() => {
            compile(content.id, newValue);
        }, 400);
    };

    return (
        <div>
            <MjmlEditor id={content.id} mjml={value} onChange={onChange} />
            {error && (
                <Typography variant="caption" style={{ color: '#f44336', display: 'block', marginTop: 4, wordBreak: 'break-word' }}>
                    {error}
                </Typography>
            )}
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    onSaveMjml: (rowId, mjml, html) => dispatch(saveMjml({ rowId, mjml, html }))
});

export default connect(null, mapDispatchToProps)(MjmlProps);
